export default {
  main: {
    hero: `
        Наши игры<br>
        это <strong>яркие</strong> миры<br>
        с <strong>очаровательными</strong><br>
        персонажами
      `,
    homescapes: `Легендарная часть серии Scapes™, в которой игрокам вместе с дворецким Остином предстоит восстановить семейный особняк`,
    township: `Увлекательный симулятор градостроительства, насыщенный яркими событиями, соревнованиями и PVP-турнирами`,
    xsolla: 'Xsolla является авторизованным глобальным дистрибьютором игр Playrix',
  },
  common: {
    login: 'Войти',
    logout: 'Выход',
    support: 'Поддержка',
    privacy: 'Конфиденциальность',
    terms: 'Условия',
    and: 'и',
    guest: 'Гость',
    loading: 'Загрузка',
    play: 'Играть',
    install: 'Установить',
  },
  auth: {
    loading: '@:(common.loading)...',
  },
  support: {
    title: 'Нужна помощь?',
    description: `Если вы пользователь этой игры и у вас возникли проблемы,
      мы будем рады помочь вам и ответить на все вопросы`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption: `Помогите дворецкому Остину вернуть тепло и комфорт в его чудесный семейный особняк.`,
    description: `Помогите дворецкому Остину вернуть тепло
      и комфорт в его чудесный семейный особняк.
      Входите - приключения ждут прямо за дверью!`,
    xsolla: 'Xsolla is an authorized global distributor of Homescapes',
    install: {
      title: '@:common.install',
      text: `Homescapes на вашем рабочем столе!
      Установите специальную веб-версию игры, и заходите в гости к Остину в два клика!`,
      button: '@:common.install',
    },
  },
  township: {
    title: 'Township',
    caption: `Станьте мэром городка Township! Стройте дома, фабрики и городские здания.`,
    description: `Станьте мэром городка Township!
      Стройте дома, фабрики и городские здания,
      выращивайте урожай и украшайте улицы!`,
    xsolla: 'Xsolla is an authorized global distributor of Township',
    install: {
      title: '@:common.install',
      text: `Township на вашем рабочем столе!
      Установите специальную веб-версию игры, и заходите в свой город в два клика!`,
      button: '@:common.install',
    },
  },
  cookie: {
    message: 'На этом сайте используются файлы cookie',
    link: 'Подробнее',
    button: 'Принять',
  },
  game: {
    notSupported: `Мобильные устройства не поддерживаются.
      Зайдите с компьютера, чтобы поиграть.`,
  },
};
